module.exports = __webpack_public_path__ + "e41dee0e81cda3525fee8188cc3949b0.svg";